import { Route } from 'types/route.type';

import ViewFileSummary from './view-file-summary';

export const routes: Route[] = [
  {
    path: '/file-upload',
    component: ViewFileSummary,
    id: 'seaCloudFileUpload.navigation.viewFileSummary'
  },
];
